export default "/images/banner-company.png?8b47c0c06932b8713909b7124a362b09";